import React, { useMemo, useRef } from 'react';
import JoditReact from 'jodit-react';

const JoditEditor = (props) => {
  const editorRef = useRef(null);

  const config = useMemo(() => ({
    height: props.height || 500,
    disabled: props.disabled || false,
    hidePoweredByJodit: true,
    toolbarAdaptive: false,
    placeholder: '',
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: 'insert_as_html',
    uploader: {
      insertImageAsBase64URI: true
    },
    buttons: [
      'undo', 'redo', '|',
      'paragraph', 'font', 'fontsize', '|',
      'bold', 'italic', 'brush', '|',
      'left', 'center', 'right', 'justify', '|',
      'ul', 'ol', 'outdent', 'indent', 'image', '|',
      'link', 'video', 'symbols', '|',
      'eraser', 'table', 'source', 'find', 'preview', 'fullsize'
    ]
  }), [props.height, props.disabled]);

  return (
    <JoditReact
      ref={editorRef}
      value={props.value ?? props.initialValue ?? ''}
      config={config}
      onChange={props.handleChange}
    />
  );
};

export default JoditEditor;
